import ShortText from './ShortText';

export default ShortText;
